import { BUTLER_JWT_TOKEN_KEY } from '@constants'
import { createRequestHelper } from '@utils/swr'
import { type AxiosInstance, type AxiosResponse } from 'axios'
import Cookies from 'js-cookie'
import { type Middleware } from 'swr'
import { type RefreshButlerTokenParams } from '../types/apiRequest'
import { type RefreshButlerTokenResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
  mutate,
} = createRequestHelper<FortuneApis['post']['refreshButlerToken'], RefreshButlerTokenResponse, RefreshButlerTokenParams>({
  client: 'fortune',
  key: params => params?.code && params?.projectCode
    ? `/campaigns/${params.code}/butler/token?project_code=${params.projectCode}`
    : null,
  fetcher: client => (_, params) => {
    const { code, projectCode } = params || {}
    return client.post(`/campaigns/${code}/butler/token?project_code=${projectCode}`)
  },
})

export const refreshButlerToken = useRequest
export const refreshButlerTokenManually = mutate
export const createWithUpdateButlerToken = (fortuneClient: AxiosInstance, butlerClient: AxiosInstance): Middleware => (useSWRNext) => {
  return (key, fetcher, config) => {
    const swr = useSWRNext(key, fetcher, {
      ...config,
      onSuccess: (...args) => {
        const token = (args[0] as AxiosResponse<RefreshButlerTokenResponse>).data.data.token
        if (token) {
          Cookies.set(BUTLER_JWT_TOKEN_KEY, token)
          fortuneClient.defaults.headers['butler-access-token'] = token
          butlerClient.defaults.headers.Authorization = `Bearer ${token}`
        }
        // FIXME: Need better error type for Middleware

        config?.onSuccess?.(...args)
      },
    })

    return swr
  }
}
